ux-iws-search-tag {
    display: inline-flex;
    flex-flow: row nowrap;

    .ux-iws-search-tag__button {
        appearance: none;
        display: inline-flex;
        flex-flow: row nowrap;
        gap: 10px;
        align-items: center;
        justify-content: center;
        min-height: 30px;
        padding: 7px 10px;
        background-color: $color-blue-menu-bg;
        border: 1px solid transparent;
        border-radius: var(--ux-tag-border-radius);
        color: $color-gray-70;
        cursor: pointer;
        font-size: var(--ux-tag-font-size);
        font-weight: var(--ux-tag-font-weight);
        line-height: 1;
        text-align: start;
        text-transform: var(--ux-tag-text-transform);
        user-select: none;
        transition: var(--ux-tag-transition);
        -moz-osx-font-smoothing: grayscale;
        -webkit-font-smoothing: antialiased;

        &:focus-visible {
            outline-offset: calc(-1 * var(--ux-button-outline-width));
            outline: var(--ux-button-outline-width) solid
                var(--ux-button-focus-border-color);
        }
    }

    ux-icon {
        color: currentColor;
        fill: currentColor;
    }

    &[active] {
        .ux-iws-search-tag__button {
            background-color: var(--ux-tag-background-color);
            color: var(--ux-tag-color);
        }
    }

    &[type="group"] {
        .ux-iws-search-tag__button {
            background-color: var(--ux-tag-background-color);
            color: var(--ux-tag-color);
        }

        .ux-iws-search-tag-filter--expanded & {
            background-color: $color-blue-menu-bg;
            color: $color-gray-70;
        }

        ux-icon[name="chevron-right"] {
            transition: transform 0.2s ease-in-out;
        }
    }

    &:hover {
        .ux-iws-search-tag__button {
            background-color: var(--ux-tag-background-color-hover);
            color: var(--ux-tag-hover-color);
        }
    }
}

.ux-iws-search-tag-group--expanded ux-iws-search-tag[type="group"] {
    ux-icon[name="chevron-right"] {
        transform: rotate(90deg);
    }
}
